import config from 'common/config';

/**
 * Global MathJax Table Observer
 * Chỉ tạo 1 observer cho toàn bộ app thay vì mỗi component 1 observer
 */
class MathTableObserver {
  constructor() {
    this.observer = null;
    this.convertTimeout = null;
    this.isObserving = false;
  }

  start() {
    if (this.isObserving) return;

    const debouncedConvert = () => {
      if (this.convertTimeout) clearTimeout(this.convertTimeout);
      this.convertTimeout = setTimeout(() => {
        config.convertMathJaxTablesToHtml(document.body);
      }, 200);
    };

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              // ELEMENT_NODE
              if (
                node.tagName === 'MJX-MTABLE' ||
                node.querySelector?.('mjx-mtable')
              ) {
                debouncedConvert();
                return; // Early exit
              }
            }
          }
        }
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    this.isObserving = true;
  }

  stop() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.convertTimeout) {
      clearTimeout(this.convertTimeout);
      this.convertTimeout = null;
    }
    this.isObserving = false;
  }
}

// Singleton instance
const globalMathTableObserver = new MathTableObserver();

export default globalMathTableObserver;
